import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { colors } from '@mui/material';


// import pdf1 from 'assests/Pdf/CIRCULAR/aryabhata_ganit_challenge.pdf';
// import pdf2 from 'assests/Pdf/CIRCULAR/ATAL_INNOVATION_MISSION.pdf';
// import pdf3 from 'assests/Pdf/CIRCULAR/Bangalore_Sahodaya_School-Complex_Online_workshop.pdf';
// import pdf4 from 'assests/Pdf/CIRCULAR/CBSECircular-3030Eklavyaseries.pdf';
// import pdf5 from 'assests/Pdf/CIRCULAR/a.pdf';
// import pdf6 from 'assests/Pdf/CIRCULAR/cbse_iris_virtual_national_fair.pdf';
// import pdf7 from 'assests/Pdf/CIRCULAR/CBSE-Circularinviting.pdf';
// import pdf8 from 'assests/Pdf/CIRCULAR/CBSE-Notification2021.pdf';
// import pdf9 from 'assests/Pdf/CIRCULAR/CBSE-ParikshaPeCharcha.pdf';
// import pdf10 from 'assests/Pdf/CIRCULAR/CBSE-specialschemeofassessment.pdf';
// import pdf11 from 'assests/Pdf/CIRCULAR/singing.pdf';
// import pdf12 from 'assests/Pdf/CIRCULAR/COVID_19.pdf';
// import pdf13 from 'assests/Pdf/CIRCULAR/Dussehra_Week_Art_Mela_Sahodaya_School.pdf';
// import pdf14 from 'assests/Pdf/CIRCULAR/FIT-INDIA.pdf';
// import pdf15 from 'assests/Pdf/CIRCULAR/GMB-campaign.pdf';
// import pdf16 from 'assests/Pdf/CIRCULAR/notification_12th_exam_cancelled.pdf';
// import pdf17 from 'assests/Pdf/CIRCULAR/onlineeasycompetition.pdf';
// import pdf18 from 'assests/Pdf/CIRCULAR/orientation_course_on_Non_Violent_Communication.pdf';
// import pdf19 from 'assests/Pdf/CIRCULAR/overcomingonlinegamingdowsides.pdf';
// import pdf20 from 'assests/Pdf/CIRCULAR/press_release_curriculum_based_comic_books_english.pdf';
// import pdf21 from 'assests/Pdf/CIRCULAR/teachers_day.pdf';
// import pdf23 from 'assests/Pdf/CIRCULAR/1.pdf';
// import pdf24 from 'assests/Pdf/CIRCULAR/2.pdf';


const Content = () => {

  const [config, setConfig] = useState({ base_image_url: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const pdf1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/aryabhata_ganit_challenge.pdf`;
  const pdf2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/ATAL_INNOVATION_MISSION.pdf`;
  const pdf3 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/Bangalore_Sahodaya_School-Complex_Online_workshop.pdf`;
  const pdf4 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/CBSECircular-3030Eklavyaseries.pdf`;
  const pdf5 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/a.pdf`;
  const pdf6 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/cbse_iris_virtual_national_fair.pdf`;
  const pdf7 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/CBSE-Circularinviting.pdf`;
  const pdf8 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/CBSE-Notification2021.pdf`;
  const pdf9 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/CBSE-ParikshaPeCharcha.pdf`;
  const pdf10 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/CBSE-specialschemeofassessment.pdf`;
  const pdf11 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/singing.pdf`;
  const pdf12 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/COVID_19.pdf`;
  const pdf13 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/Dussehra_Week_Art_Mela_Sahodaya_School.pdf`;
  const pdf14 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/FIT-INDIA.pdf`;
  const pdf15 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/GMB-campaign.pdf`;
  const pdf16 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/notification_12th_exam_cancelled.pdf`;
  const pdf17 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdfCIRCULAR/onlineeasycompetition.pdf`;
  const pdf18 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/orientation_course_on_Non_Violent_Communication.pdf`;
  const pdf19 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/overcomingonlinegamingdowsides.pdf`;
  const pdf20 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/press_release_curriculum_based_comic_books_english.pdf`;
  const pdf21 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/teachers_day.pdf`;
  const pdf23 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/1.pdf`;
  const pdf24 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CIRCULAR/2.pdf`;
  

  const mock = [
    {
      title: ' Har Ghar Tiranga Program',
      href: pdf23
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: ' Celebration of Har Ghar Tiranga campaign under Azadi ka Amrit Mahotsav',
      href: pdf24
      // subtitle: 'Issues related to authentication',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: ' CBSE Circular-Inviting Citizen Registrations for watching Live Streaming of Republic Day Parade and Beating Retreat Ceremony 2022',
      href: pdf7
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'Overcoming online gaming downsides',
      href: pdf19
      // subtitle: 'Issues related to authentication',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE Circular-3030 Eklavya Series',
      href: pdf4
      // subtitle: 'Issues related to renewal',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'Circular- Singing of Rashtragaan',
      href: pdf11
      // subtitle: 'Payment gateway related issues',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Special Scheme of Assessment for Class X and XII 2021-22.',
      href: pdf10
      // subtitle: 'Login session related issues',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Notification 12th Exam Cancelled',
      href: pdf16
      // subtitle: 'Referral bonuses and charging',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Curriculum based Comic Books English',
      href: pdf20
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Notification 2021',
      href: pdf8
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Pariksha Pe Charcha',
      href: pdf9
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - IRIS Virtual National Fair',
      href: pdf6
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Dussehra Week Art Mela - Sahodaya School',
      href: pdf13
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Bangalore Sahodaya School Complex - Online workshop',
      href: pdf3
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: ' CBSE - COVID 19',
      href: pdf12
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Orientation course on non - violent communication',
      href: pdf18
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Career opportunities in Indian Air Force',
      href: pdf5
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Atal Innovation Mission',
      href: pdf2
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Teachers Day',
      href: pdf21
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - FIt India',
      href:  pdf14
      
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'Gandagi Mukt Bharat (GMB) Campaign',
      href: pdf15
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'Online Essay Competition',
      href: pdf17
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    {
      title: 'CBSE - Aryabhata Ganit Challenge',
      href: pdf1
      // subtitle: 'Issues related to logging in, out, or about multiple devices.',
      // text:
      //   'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    },
    
  ];
  

  return (
    <Box>
      <Box marginBottom={1}>
        <Box marginBottom={2} display={'flex'} alignItems={'center'}>
          <Box
            component={Avatar}
            bgcolor={colors.green[100]}
            color={colors.green[900]}
            marginBottom={1}
            width={60}
            height={60}
          >
            <Box
              component={'svg'}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              width={24}
              height={24}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
              />
            </Box>
          </Box>
          <Box marginLeft={2}>
            <Typography variant={'h6'} fontWeight={700} >
              CIRCULAR
            </Typography>
            <Typography color={'text.secondary'}>
              {/* Let’s try to fix your billing issues. */}
            </Typography>
          </Box>
        </Box>
        <Box display={'flex'} alignItems={'center'}>
          <Box
            paddingY={1 / 2}
            paddingX={1}
            // bgcolor={'secondary.main'}
            borderRadius={2}
            marginRight={1}
          >
            <Typography
              variant={'caption'}
              fontWeight={700}
              sx={{ color: 'common.black' }}
            >
              {/* 8 answers */}
            </Typography>
          </Box>
          <Typography
            color={'text.secondary'}
            variant={'caption'}
            fontWeight={700}
          >
            {/* Last updated 10 days ago */}
          </Typography>
        </Box>
      </Box>
      <Box>
        {mock.map((item, i) => (
          <Box
            component={Accordion}
            key={i}
            paddingY={1}
            elevation={0}
            sx={{
              '&:first-of-type': {
                borderTopLeftRadius: 1,
                borderTopRightRadius: 1,
              },
              '&:not(:first-of-type):before': {
                opacity: '1 !important',
                display: 'block !important',
              },
              '&.Mui-expanded': {
                margin: 0,
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id={`panel1a-header--${i}`}
              padding={'0 !important'}
            >
              <Box>
                <Typography fontWeight={600}>{item.title}</Typography>
                <Typography color="text.secondary">{item.subtitle}</Typography>
              </Box>
            </Box>
            <AccordionDetails>
              <Typography>{item.text}</Typography>
              <Box display={'flex'} justifyContent={'flex-end'}>
                <Box
                  component={Button}
                  href= {item.href}
                  color="primary"
                  size="small"
                  marginTop={2}
                  variant={'outlined'}
                  endIcon={
                    <Box
                      component={'svg'}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      width={24}
                      height={24}
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      />
                    </Box>
                  }
                  sx={{ float: 'right' }}
                >
                  Know more
                </Box>
              </Box>
            </AccordionDetails>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Content;